<!-- SwipFx Orders Page - Filterable Order Book (Bootstrap 5) -->
<!-- Tabs need bootstrap.bundle.js -->
<div class="min-vh-100 bg-light">

    <app-header [page]="'Accounts'"></app-header>
    <main class="container py-4">

  <div class="d-flex flex-wrap justify-content-between align-items-center gap-3 mb-4">
    <div>
      <h3 class="fw-bold mb-1">Compliance Wizard</h3>
      <p class="text-muted mb-0">Complete your verification in four guided steps.</p>
    </div>

    <button class="btn btn-outline-secondary btn-sm" routerLink="/compliance">
      Back to Dashboard
    </button>
  </div>

  <div *ngIf="loading" class="card border-0 shadow-sm">
    <div class="card-body text-center py-5">
      <div class="spinner-border spinner-border-sm me-2"></div>
      Loading application...
    </div>
  </div>

  <div *ngIf="!loading && errorMessage" class="alert alert-danger">
    {{ errorMessage }}
  </div>

  <ng-container *ngIf="!loading && application as app">
    <div class="card border-0 shadow-sm mb-4">
      <div class="card-body">
        <div class="row g-3 align-items-center">
          <div class="col-lg-8">
            <div class="small text-muted">Application</div>
            <div class="fw-semibold">
              {{ app.jurisdictionCode }} · {{ app.tierCode }}
            </div>
            <div class="small text-muted">
              Status: {{ app.status }} · Started {{ app.startedAt | date:'medium' }}
            </div>
          </div>

          <div class="col-lg-4">
            <div class="d-flex flex-wrap gap-2 justify-content-lg-end">
              <button
                type="button"
                class="btn btn-outline-secondary btn-sm"
                [class.active]="activeStep === 1"
                (click)="setStep(1)">
                Fields
              </button>

              <button
                type="button"
                class="btn btn-outline-secondary btn-sm"
                [class.active]="activeStep === 2"
                (click)="setStep(2)">
                Documents
              </button>

              <button
                type="button"
                class="btn btn-outline-secondary btn-sm"
                [class.active]="activeStep === 3"
                (click)="setStep(3)">
                Validate
              </button>

              <button
                type="button"
                class="btn btn-outline-secondary btn-sm"
                [class.active]="activeStep === 4"
                (click)="setStep(4)">
                Review
              </button>
            </div>
          </div>
        </div>

        <div *ngIf="app.reviewNotes" class="alert alert-warning mt-3 mb-0">
          <strong>Review notes:</strong> {{ app.reviewNotes }}
        </div>
      </div>
    </div>

    <div [ngSwitch]="activeStep">

      <app-compliance-fields-step
        *ngSwitchCase="1"
        [form]="fieldsForm"
        [fields]="app.fields || []">
      </app-compliance-fields-step>

      <div *ngSwitchCase="1" class="d-flex justify-content-end mt-3">
        <button
          class="btn btn-primary"
          (click)="saveFields()"
          [disabled]="savingFields || !canEdit()">
          <span *ngIf="savingFields" class="spinner-border spinner-border-sm me-2"></span>
          Save & Continue
        </button>
      </div>
      
      <app-compliance-documents-step
        *ngSwitchCase="2"
        [uploadedDocuments]="app.documents || []"
        [policyDocuments]="app.policy?.documents || []"
        [draftDocumentTypeCode]="draftDocumentTypeCode"
        [draftExpiryDate]="draftExpiryDate"
        [uploadBusy]="uploadBusy"
        [deletingDocumentId]="deletingDocumentId"
        [canEdit]="canEdit()"
        (documentTypeCodeChanged)="onDocumentTypeCodeChanged($event)"
        (expiryDateChanged)="onExpiryDateChanged($event)"
        (fileSelected)="onFileSelected($event)"
        (uploadClicked)="uploadDocument()"
        (deleteClicked)="deleteDocument($event)">
      </app-compliance-documents-step>

      <div *ngSwitchCase="2" class="d-flex justify-content-between mt-3">
        <button class="btn btn-outline-secondary" (click)="setStep(1)">
          Back
        </button>

        <button class="btn btn-primary" (click)="validateApplication()">
          <span *ngIf="validating" class="spinner-border spinner-border-sm me-2"></span>
          Run Validation
        </button>
      </div>

      <app-compliance-validate-step
        *ngSwitchCase="3"
        [validationResult]="validationResult">
      </app-compliance-validate-step>

      <div *ngSwitchCase="3" class="d-flex justify-content-between mt-3">
        <button class="btn btn-outline-secondary" (click)="setStep(2)">
          Back
        </button>

        <button class="btn btn-primary" (click)="continueToReview()">
          Continue to Review
        </button>
      </div>

      <app-compliance-review-step
        *ngSwitchCase="4"
        [application]="app">
      </app-compliance-review-step>

      <div *ngSwitchCase="4" class="d-flex justify-content-between mt-3">
        <button class="btn btn-outline-secondary" (click)="setStep(3)">
          Back
        </button>

        <button
          class="btn btn-success"
          (click)="submitApplication()"
          [disabled]="submitting">
          <span *ngIf="submitting" class="spinner-border spinner-border-sm me-2"></span>
          Submit Application
        </button>
      </div>

    </div>
  </ng-container>
<app-footer></app-footer>
    </main>
    </div>